module.exports = __webpack_public_path__ + "static/galvan_magen-70a73f129bfaeb0be646105ce26a217e.jpg";